/** @format */

import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        console.error(error, errorInfo); // eslint-disable-line
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="container d-flex h-100">
                    <div className="row justify-content-center align-self-center">
                        <div>
                            <div>
                                <h2 className="quoter-step__title mb-3">Oh My!</h2>
                            </div>
                            <div>Something is not quite right.</div>
                            <div>
                                <em>It is not your fault. You are awesome.</em>
                            </div>
                            <div>
                                Please reload the page and try again or call us if this continues to
                                happen.
                            </div>
                            <div>877.277.4682</div>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
